<div class="collection-container">
    <div>
        <div
            class="my-3 px-2 p-0 d-flex justify-content-between align-items-center status-container"
            *ngIf="
                collection$?.value?.length > 8 &&
                (dashboardFacade.isChangeView$ | async) === false
            "
        >
            <div
                class="h-100 d-flex justify-content-center align-items-center m-0 status"
                *ngFor="let status of availableStatus"
                [ngStyle]="{
                    'background-color': status.statusFamilyColor
                }"
                [ngClass]="{
                    active: status.statusFamilyName === activeStatus,
                    'status-all': status.statusFamilyName === 'all'
                }"
                (click)="statusSelection(status.statusFamilyName)"
            >
                {{ status.value }} - {{ status.statusFamilyName | lang }}
            </div>
        </div>

        <app-machine-status
            [ngClass]="{ 'fade-in-up': animate }"
            [machines]="machines"
            [isHCM]="isHcm"
            [isScoop]="isScoop"
        ></app-machine-status>
    </div>
</div>
